import React, { useEffect, useState } from "react";
import { Box, Card, CardContent, Typography } from "@mui/material";
import ShowBarChart from "../Components/BarChart";
import PieChartData from "../Components/PieChart";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchDashboardData,
  fetchDashboardSummaryCost,
  getShipmentsByData,
  getShipmentsDataByDestination,
  getShipmentsDataByDestinationAndDays,
  getShipmentsDataByValue,
  getShipmentsDataByVolume,
  getShipmentsDataTotal,
  getTotalShipmentsData,
} from "../slice/dashboardSlice";
import EventIcon from "@mui/icons-material/Event";
import { formatNumberWithCommas } from "../utils/formatNumberWithCommas";
import Loader from "../Components/Loader";
import { useTheme } from "@mui/material/styles";
import ShipmentsTable from "../Components/ShipmentsTable";
import PieChartData2 from "../Components/PieChart2";
import Dropdown from "../Components/CustomDropdown";
import DateRangePicker from "../Components/DateRangePicker";
import { lastDaysOptions } from "../constants";
import DownloadIcon from "@mui/icons-material/Download";
import { exportToExcel } from "../utils/dashbaord";


const Dashboard1 = () => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const [volumeDays, setVolumeDays] = useState(30);

  const [valueDays, setValueDays] = useState(30);
  const [destinationDays, setDestinationDays] = useState(30);

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const [valueStartDate, setValueStartDate] = useState(null);
  const [valueEndDate, setValueEndDate] = useState(null);

  const [destinationStartDate, setDestinationStartDate] = useState(null);

  const [destinationEndDate, setDestinationEndDate] = useState(null);

  const [ shipmentsStartDate, setShipmentsStartDate] = useState(null);
  const [shipmentsEndDate, setShipmentsEndDate] = useState(null);

  const {
    currentMonth,
    lastMonth,
    totalCarrierCost,
    totalCustomerPrice,
    profit,
    totalShipments,
    shipmentsByVolumeLoading,
    shipmentsByValueLoading,
    shipmentsByDestinationLoading,
    shipmentsByVolume = [],
    shipmentsByValue = [],
    shipmentsByDestination = [],
    shipmentsByDestinationAndDays = [],
    totalShipmentsCarrierCost,
    totalShipmentsCustomerPrice,
    totalShipmentsProfit,
    allShipments,
    totalShipmentsLoading = false,
    shipmentsByData,
    shipmentsByDataTotal,
    shipmentsByCost,
  } = useSelector((state) => state.dashboard || {});
  const userRole = useSelector((state) => state.user.userRole);
  const isAdmin = userRole === "admin";

  // console.log(shipmentsByVolume,'jjjj')

  // let totalPackagesCount = 0;

  // shipmentsByVolume.forEach(item => {
  //   totalPackagesCount += item.packages?.length || 0;
  // });  
  // console.log('Total packages (CSrows):', totalPackagesCount);


  // // console.log(shipmentsByValue,'shipmentsByValue')

  // let totalPackagesValue = 0

  // shipmentsByValue.forEach((item)=>{
  //  totalPackagesValue+= item?.totalValue || 0

  // })


  //   console.log('Total packages value (CSrows):', totalPackagesValue);

  const handleResize = () => {
    setWindowWidth(window.innerWidth);
  };
    
  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    dispatch(fetchDashboardData());
    dispatch(fetchDashboardSummaryCost());
    dispatch(getTotalShipmentsData());
    dispatch(getShipmentsDataByDestinationAndDays());
  }, [dispatch]);

  useEffect(() => {
    dispatch(getShipmentsDataByVolume());
  }, [dispatch]);


  useEffect(() => {
    dispatch(getShipmentsDataByValue());
  }, [dispatch]);

  useEffect(() => {
    if (destinationDays !== "none") {
      dispatch(getShipmentsDataByDestination({ days: destinationDays }));
    }
  }, [dispatch, destinationDays]);
  

  useEffect(() => {
    dispatch(getShipmentsByData({ days: destinationDays }));
  }, [dispatch, destinationDays]);


  const handleValueDaysChange = (event) => {
    setValueDays(event.target.value);
    if (event.target.value !== "none")
      dispatch(getShipmentsDataByValue({ days: event.target.value }));
  };

  const handleValueDateChange = (start, end) => {
    setValueDays("none");
    setValueStartDate(start);
    setValueEndDate(end);
    if (start && end) {
      dispatch(
        getShipmentsDataByValue({
          startDate: start,
          endDate: end,
        })
      );
    }
  };

  const handleVolumeDaysChange = (event) => {
    setStartDate("");
    setEndDate("");
    setVolumeDays(event.target.value);
    if (event.target.value !== "none")
      dispatch(getShipmentsDataByVolume({ days: event.target.value }));
  };

  const handleDestinationDaysChange = (event) => {
    setDestinationDays(event.target.value);
  };

  const handleDateChange = (start, end) => {
    setVolumeDays("none");
    setStartDate(start);
    setEndDate(end);
    if (start && end) {
      dispatch(
        getShipmentsDataByVolume({
          startDate: start,
          endDate: end,
        })
      );
    }
  };

  const handleShipmentsDateChange = (start, end) => {
    setShipmentsStartDate(start);
    setShipmentsEndDate(end);
    if (start && end) {
      dispatch(fetchDashboardSummaryCost({ startDate: start, endDate: end }))
      dispatch(
        getShipmentsDataTotal({
          startDate: start,
          endDate: end,
        })
      );
  }
  };
  

  const handleDestinationDateChange = (start, end) => {
    // Immediately update the state
    setDestinationDays("none");
    setDestinationStartDate(start);
    setDestinationEndDate(end);
  
    console.log("Start Date:", start);
    console.log("End Date:", end);
  
    if (start && end) {
      dispatch(
        getShipmentsByData({
          startDate: start,
          endDate: end,
        })
      );
  
      dispatch(
        getShipmentsDataByDestination({
          startDate: start,
          endDate: end,
        })
      );
    } else {
      console.log("Both start and end dates are required.");
    }
  };

  const shipmentsByVolumeData = shipmentsByVolume.map((ship) => {
    return {
      id: ship.carrierVersion.toUpperCase(),
      value: ship.shipmentCount,
      label: ship.carrierVersion.toUpperCase(),
    };
  });

  const shipmentsByValueData = shipmentsByValue.map((ship) => {
    return {
      id: ship.carrierVersion.toUpperCase(),
      value: ship.totalValue,
      label: ship.carrierVersion.toUpperCase(),
    };
  });

  const shipmentsByDestinationData = shipmentsByDestination.map((ship) => {
    return {
      id: ship.receiverCountry.toUpperCase(),
      value: ship.shipmentCount,
      label: ship.receiverCountry.toUpperCase(),
    };
  });


  const items = [
    { id: "totalSales", value: shipmentsByCost?.totalShipments, label: "Total Shipments" },
    {
      id: " totalCustomerPrice",
      value: shipmentsByCost?.totalCustomerPrice,
      label: " Total Customer Price (we received)",
    },
    ...(isAdmin
      ? [
          {
            id: "totalRevenue",
            value: shipmentsByCost?.totalRevenue,
            label: "Total Revenue (we paid)",
          },
          { id: "profit", value: shipmentsByCost?.profit, label: "Total Profit" },
        ]
      : []),
  ];

  const validItems = items && items?.length > 0 ? items : [];

  return (
    <Box className="p-4 bg-gray-100 min-h-screen">
      <Box className="mb-4">
        <Typography variant="h4" className="font-bold">
          Dashboard
        </Typography>
      </Box>
      {/* chart section */}
      <Box className="rounded mb-4">
        <Box className="flex bg-gray-100 rounded-lg flex-wrap gap-4 mb-4">
          <Box
            className="flex-1 rounded min-w-[200px] bg-white"
            style={{ flex: "0 0 100%" }}
          >
            <Typography
              variant="h6"
              className="mb-2 border-b border-[#bdbbbb] p-2"
            >
              Shipments By Per Month
            </Typography>
            <Box className="h-80 rounded flex justify-center items-center">
              <ShowBarChart />
            </Box>
          </Box>
        </Box>

        <Box className="flex-1 rounded w-full bg-white mb-4">
          <Box className="flex justify-between p-2 items-center border-b border-[#bdbbbb]">
            <Typography variant="h6" className="mb-2 mr-10" >
              Shipments (Total)
            </Typography>
            <Box className="flex justify-between gap-4">
              <DateRangePicker
                selectedStartDate={shipmentsStartDate}
                selectedEndDate={shipmentsEndDate}
                onDateChange={handleShipmentsDateChange}
                maxDate={new Date()}
                className="border border-gray-300 rounded w-full"
              />               
              <button
                  className="flex items-center border border-blue text-blue px-3  p-1 rounded  hover:bg-blue-100 transition ml-12"
                  onClick={() => exportToExcel( shipmentsByDataTotal ,isAdmin , true)}
                >
                  <DownloadIcon sx={{ fontSize: 22 }} className="mr-2" />
                  Export
                </button>
            </Box>
          </Box>
          <Box className="h-80 rounded bg-white flex items-center justify-center">
            {totalShipmentsLoading ? (
              <Loader inline />
            ) : (
              <PieChartData2
                items={validItems}
                width={windowWidth < 1280 ? 650 : 1000}
                windowWidth={windowWidth}
              />
            )}
          </Box>
        </Box>

          <Box className="flex-1 rounded bg-white mb-4 w-full">
            <Box className="flex justify-between items-center border-b border-[#bdbbbb] p-2">
              <Typography variant="h6" className="mb-2">
                Shipments By Volume
              </Typography>
              <Box className="flex gap-4">
                <Box className="mr-[6rem]">
                  <DateRangePicker
                    selectedStartDate={volumeDays === "none" ? startDate : ""}
                    selectedEndDate={volumeDays === "none" ? endDate : ""}
                    onDateChange={handleDateChange}
                    maxDate={new Date()}
                    className="border border-gray-300 rounded w-full"
                  />

                </Box>
                <Dropdown
                  label="Last Days"
                  options={lastDaysOptions}
                  selectedValue={startDate || endDate ? "none" : volumeDays}
                  handleChange={handleVolumeDaysChange}
                  width={110}
                />
                <button
                  className="flex items-center border border-blue text-blue px-3 rounded ml-0 hover:bg-blue-100 transition"
                  onClick={() => exportToExcel(shipmentsByVolume,isAdmin)}
                >
                  <DownloadIcon sx={{ fontSize: 22 }} className="" />
                  Export
                </button>
              </Box>
            </Box>
            <Box className="rounded bg-white flex items-center justify-center">
              {shipmentsByVolumeLoading ? (
                <Loader inline />
              ) : (
                <PieChartData
                  items={shipmentsByVolumeData}
                  width={windowWidth < 1280 ? 650 : 1000}

                  windowWidth={windowWidth}
                />
              )}
            </Box>
          </Box>

          <Box className="flex-1 w-full mb-4 rounded bg-white">
            <Box className="flex justify-between items-center border-b border-[#bdbbbb] p-2">
              <Typography
                variant={windowWidth > 768 ? "h6" : "h6"}
                className="mb-2"
              >
                Shipments By Value ($)
              </Typography>
             
              <Box className="flex gap-4">
                <Box className="mr-[6rem]">
                  <DateRangePicker
                    selectedStartDate={
                      valueDays === "none" ? valueStartDate : ""
                    }
                    selectedEndDate={valueDays === "none" ? valueEndDate : ""}
                    onDateChange={handleValueDateChange}
                    maxDate={new Date()}
                    className="border border-gray-300 rounded w-full "
                  />
                </Box>
                <Dropdown
                  label="Last Days"
                  options={lastDaysOptions}
                  selectedValue={valueDays}
                  handleChange={handleValueDaysChange}
                  width={110}
                />
                 <button
                className="flex  items-center border border-blue text-blue  px-3  p-1 rounded  hover:bg-blue-100 transition"
                onClick={() => exportToExcel(shipmentsByValue,isAdmin)}
              >
                <DownloadIcon sx={{ fontSize: 22 }} className="mr-2" />
                Export
              </button>
              </Box>
            </Box>
            <Box className="h-80  rounded flex items-center justify-center">
              {shipmentsByValueLoading ? (
                <Loader inline />
              ) : (
                <PieChartData
                  items={shipmentsByValueData}
                  width={windowWidth < 1280 ? 650 : 1000}

                  windowWidth={windowWidth}
                />
              )}
            </Box>
          </Box>
  
          <Box className="flex-1 w-full rounded mb-4 bg-white">
            <Box className="flex justify-between items-center border-b border-[#bdbbbb] p-2">
              <Typography sx={{ fontSize: 18 }} className="mb-2 ">
                Shipments By Destinations
              </Typography>
              
              <Box className="flex gap-4">
                <Box className="mr-[6rem]">
                  <DateRangePicker
                    selectedStartDate={
                      destinationDays === "none" ? destinationStartDate : ""
                    }
                    selectedEndDate={
                      destinationDays === "none" ? destinationEndDate : ""
                    }
                    onDateChange={handleDestinationDateChange}
                    maxDate={new Date()}
                    className="border border-gray-300 rounded w-full"
                  />
                </Box>
                <Dropdown
                  label="Last Days"
                  options={lastDaysOptions}
                  selectedValue={destinationDays}
                  handleChange={handleDestinationDaysChange}
                  width={110}
                />
                <button
                  className="flex items-center border border-blue text-blue px-3  p-1 rounded hover:bg-blue-100 transition"
                  onClick={() => exportToExcel( shipmentsByData ,isAdmin , true)}
                >
                  <DownloadIcon sx={{ fontSize: 22 }} className="mr-2" />
                  Export
                </button>
              </Box>
            </Box>
            <Box className="h-80 rounded flex items-center justify-center">
              {shipmentsByDestinationLoading ? (
                <Loader inline />
              ) : (
                <PieChartData2
                  items={shipmentsByDestinationData}
                  width={windowWidth < 1280 ? 650 : 1000}
                />
              )}
            </Box>
          </Box>   

        <Box className="flex flex-wrap bg-gray-100 gap-4 mb-4">
          {
            <Box
              className="flex-1 rounded p-4 bg-white"
              style={{ flex: "0 0 100%" }}
            >
              <Typography variant="h6" className="mb-2">
                Shipments By Destination
              </Typography>
              <Box className="flex-1 rounded flex justify-center items-center">
                <ShipmentsTable shipmentsData={shipmentsByDestinationAndDays} />
              </Box>
            </Box>
          }
        </Box>

        {/* Overview Section */}
        <Box className="flex flex-wrap gap-4 mb-4">
          <Card className="flex-1 bg-white min-w-[200px]">
            <CardContent>
              <Typography variant="h6">
                {formatNumberWithCommas(allShipments) || 0}
              </Typography>
              <Typography variant="body2" color="textSecondary">
                <span style={{ fontWeight: "bold" }}>Total Shipments </span>
              </Typography>
            </CardContent>
          </Card>

          <Card className="flex-1 bg-white min-w-[200px]">
            <CardContent>
              <Typography variant="h6">
                $ {formatNumberWithCommas(totalShipmentsCustomerPrice) || 0.0}
              </Typography>
              <Typography variant="body2" color="textSecondary">
                <span style={{ fontWeight: "bold" }}>
                  Total Customer Price{" "}
                </span>{" "}
                (we received)
              </Typography>
            </CardContent>
          </Card>
          {isAdmin && (
            <>
              <Card className="flex-1 bg-white min-w-[200px]">
                <CardContent>
                  <Typography variant="h6">
                    $ {formatNumberWithCommas(totalShipmentsCarrierCost) || 0.0}
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    <span style={{ fontWeight: "bold" }}>Total Revenue </span>{" "}
                    (we paid)
                  </Typography>
                </CardContent>
              </Card>
              <Card className="flex-1 bg-white min-w-[200px]">
                <CardContent>
                  <Typography variant="h6">
                    $ {formatNumberWithCommas(totalShipmentsProfit) || 0.0}
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    <span style={{ fontWeight: "bold" }}>Total Profit</span>
                  </Typography>
                </CardContent>
              </Card>
            </>
          )}
        </Box>
      </Box>
      {/* Current Month Section */}
      <Box className="bg-white rounded p-4 mb-4">
        <Box className="flex items-center gap-2 mb-4">
          <Typography variant="h4" className="font-bold text-gray-800">
            Current Month
          </Typography>
          <EventIcon
            sx={{ color: theme.palette.secondary.main }}
            fontSize="medium"
          />
        </Box>
        <Box className="flex flex-wrap gap-4 mb-4">
          <Card className="flex-1 min-w-[200px] bg-white">
            <CardContent>
              <Typography variant="h6">
                {formatNumberWithCommas(currentMonth?.totalShipments) || 0}
              </Typography>
              <Typography variant="body2" color="textSecondary">
                <span style={{ fontWeight: "bold" }}>Shipments </span>
              </Typography>
            </CardContent>
          </Card>

          <Card className="flex-1 min-w-[200px] bg-white">
            <CardContent>
              <Typography variant="h6">
                ${" "}
                {formatNumberWithCommas(currentMonth?.totalCustomerPrice) ||
                  0.0}
              </Typography>
              <Typography variant="body2" color="textSecondary">
                <span style={{ fontWeight: "bold" }}>Customer Price </span> (we
                received)
              </Typography>
            </CardContent>
          </Card>
          {isAdmin && (
            <>
              <Card className="flex-1 min-w-[200px] bg-white">
                <CardContent>
                  <Typography variant="h6">
                    ${" "}
                    {formatNumberWithCommas(currentMonth?.totalCarrierCost) ||
                      0.0}
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    <span style={{ fontWeight: "bold" }}>Revenue </span> (we
                    paid)
                  </Typography>
                </CardContent>
              </Card>
              <Card className="flex-1 min-w-[200px] bg-white">
                <CardContent>
                  <Typography variant="h6">
                    $ {formatNumberWithCommas(currentMonth?.profit) || 0.0}
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    <span style={{ fontWeight: "bold" }}>Profit</span>
                  </Typography>
                </CardContent>
              </Card>
            </>
          )}
        </Box>
      </Box>
      {/* Last Month Section */}
      <Box className="bg-white rounded p-4 mb-4">
        <Box className="mb-2 flex items-center gap-2">
          <Typography variant="h4" className="font-bold">
            Last Month
          </Typography>
          <EventIcon
            sx={{ color: theme.palette.secondary.main }}
            fontSize="medium"
          />
        </Box>
        <Box className="flex flex-wrap gap-4 mb-4">
          <Card className="flex-1 min-w-[200px] bg-white">
            <CardContent>
              <Typography variant="h6">
                {formatNumberWithCommas(lastMonth?.totalShipments) || 0}
              </Typography>
              <Typography variant="body2" color="textSecondary">
                <span style={{ fontWeight: "bold" }}>Shipments </span>
              </Typography>
            </CardContent>
          </Card>

          <Card className="flex-1 min-w-[200px] bg-white">
            <CardContent>
              <Typography variant="h6">
                $ {formatNumberWithCommas(lastMonth?.totalCustomerPrice) || 0.0}
              </Typography>
              <Typography variant="body2" color="textSecondary">
                <span style={{ fontWeight: "bold" }}>Customer Price </span> (we
                received)
              </Typography>
            </CardContent>
          </Card>
          {isAdmin && (
            <>
              <Card className="flex-1 min-w-[200px] bg-white">
                <CardContent>
                  <Typography variant="h6">
                    ${" "}
                    {formatNumberWithCommas(lastMonth?.totalCarrierCost) || 0.0}
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    <span style={{ fontWeight: "bold" }}>Revenue </span> (we
                    paid)
                  </Typography>
                </CardContent>
              </Card>
              <Card className="flex-1 min-w-[200px] bg-white">
                <CardContent>
                  <Typography variant="h6">
                    $ {formatNumberWithCommas(lastMonth?.profit) || 0.0}
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    <span style={{ fontWeight: "bold" }}>Profit</span>
                  </Typography>
                </CardContent>
              </Card>
            </>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default Dashboard1;
